import classNames from "classnames";
import React, { useMemo } from "react";
import { Image as ImageComp } from "./../../ui-components";
import { RICOS_DEFAULTS } from "../consts";
import { EXPAND_BUTTON } from "../data-hooks";
import ExpandIcon from "../icons/expand";
import classes from "../statics/styles/image-viewer.rtlignore-scss";
import { ImageContainer } from "./image-container";
import { useCustomWidthStyle } from "./use-custom-width-style";
import { useFallbackWidthStyle } from "./use-fallback-width-style";
import { useImageDimensions } from "./use-image-dimensions";
import { useImageSocialAttributes } from "./use-image-social-attributes";
const Image = ({
  dataUrl,
  node,
  className,
  config,
  helpers,
  isMobile,
  seoMode,
  imageClickActionConfig,
  expand,
  shouldLazyLoadImages
}) => {
  const containerData = node.imageData?.containerData || RICOS_DEFAULTS.containerData;
  const { image, altText, decorative, styles } = node.imageData || {};
  const { src } = image || {};
  const imageSource = useMemo(() => {
    if (dataUrl) {
      return dataUrl;
    }
    const { url, id } = src || {};
    if (url) {
      return url;
    }
    const { getImageUrl } = helpers ?? {};
    if (getImageUrl && id) {
      return getImageUrl({ file_name: id });
    }
    return id;
  }, [
    dataUrl,
    node.imageData?.image?.src?.url,
    node.imageData?.image?.src?.id,
    helpers?.getImageUrl
  ]);
  const { width, height } = useImageDimensions({
    src: imageSource,
    containerData,
    image
  });
  const fallbackWidthStyle = useFallbackWidthStyle({ containerData, isMobile });
  const customWidthStyle = useCustomWidthStyle({ containerData, isMobile, width });
  const socialAttributes = useImageSocialAttributes({
    config,
    src,
    width: image?.width,
    height: image?.height
  });
  const style = {
    borderRadius: styles?.border?.radius,
    border: `${styles?.border?.width || 0}px solid ${styles?.border?.color ?? config?.colors?.color8 ?? ""}`
  };
  const doDimensionsExist = width !== void 0 && height !== void 0;
  return /* @__PURE__ */ React.createElement(ImageContainer, { ...imageClickActionConfig, disableDownload: node.imageData?.disableDownload }, doDimensionsExist && imageSource && /* @__PURE__ */ React.createElement(
    ImageComp,
    {
      id: node.imageData?.image?.src?.id ?? imageSource,
      containerId: node.id,
      displayMode: "fill",
      width,
      height,
      uri: node.imageData?.image?.src?.id ?? imageSource,
      alt: decorative ? "" : altText || toCaptionPlainText(node) || "",
      role: decorative ? "presentation" : void 0,
      containerProps: {
        className: classNames(classes.imageWrapper, classes.imageRatio, className, {
          [classes.pointer]: !!expand
        }),
        containerId: node.id,
        style: {
          ["--dim-height"]: height,
          ["--dim-width"]: width,
          ...fallbackWidthStyle,
          ...customWidthStyle,
          ...style
        }
      },
      imageStyles: {
        maxWidth: "100%"
      },
      socialAttrs: { ...socialAttributes, draggable: false },
      isSEOBot: !!seoMode,
      encoding: config?.encoding,
      ...shouldLazyLoadImages ? {
        placeholderTransition: seoMode ? void 0 : "blur",
        shouldUseLQIP: config?.disableTransition !== false
      } : {}
    }
  ), !!expand && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classes.expandContainer,
      onClick: expand,
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          expand(e);
        }
      },
      role: "button",
      tabIndex: 0,
      "data-hook": EXPAND_BUTTON
    },
    /* @__PURE__ */ React.createElement(ExpandIcon, { className: classes.expandIcon })
  ));
};
const toCaptionPlainText = (imageNode) => {
  if (!imageNode.nodes?.[0]?.nodes?.length) {
    return "";
  }
  return imageNode.nodes[0].nodes.map((node) => node.textData.text).join("");
};
export {
  Image
};
//# sourceMappingURL=image.js.map
